import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

// Utils
import history from '../../../history'

// Constants
import { OVERLAY_HELPERS } from '../../../constants/navigation'

// Selectors
import { selectSmsLongCode } from '../../../store/selectors/clientEvents'

// Components
import { Text, Button, Format, Page } from '../..'
import { TEXT_UPDATE_PAGES } from './.'

// Assets
import SmsStart from './assets/SmsStart.svg'

// Styles
import styles from './TwilioStartHelper.module.scss'

const TwilioStartHelper = () => {
  const longCode = useSelector(selectSmsLongCode)

  const navUpdateMobile = () => history.replace(OVERLAY_HELPERS.textUpdates.buildPath(TEXT_UPDATE_PAGES.UPDATE))

  return (
    <Page.Body className={styles.body}>
      <div className={styles.svg}>
        <SmsStart />
      </div>
      <div className={styles.header}>
        <Text size='xl' variant='neutralCool' variantCount='900'>
          <FormattedMessage id='TextUpdates.panel.twilio.title' defaultMessage='Resubscribe to text updates' />
        </Text>
        <Text variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='TextUpdates.panel.twilio.subTitle1'
            defaultMessage='You replied STOP to {longCode}.'
            values={{
              longCode: <Format.Phone value={longCode} />
            }}
          />
        </Text>
        <Text variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='TextUpdates.panel.twilio.subTitle2'
            defaultMessage='To start getting text updates again, search your messages for {longCode} and type ‘START’'
            values={{
              longCode: <Format.Phone value={longCode} />
            }}
          />
        </Text>
      </div>
      <Button fullWidth onClick={navUpdateMobile}>
        <FormattedMessage id='TextUpdate.twilio.navUpdate' defaultMessage='Or add a new mobile number' />
      </Button>
    </Page.Body>
  )
}

export default TwilioStartHelper
